"use strict";
export const MORPHEX_API_BASE_URL = "https://api-v2.morphex.trade";
export const DEFAULT_DELI_CHAIN_ID = 8453;
export const DELI_HOOK_ADDRESS = "0x570A48F96035C2874de1c0F13c5075A05683b0cc";
export const DELI_HOOK_CP_ADDRESS = "0x95AFBC0FCcF974B41380f24e562f15b6DD90faC8";
export const LIQUIDITY_POOL_FEE_TIER_OVERRIDES = {
  "0x02aaacb8bf6a4c3c3a99d8de43fad01348e68e314b7773fb2df3edac065e0c4e": 3e3,
  // wBLT/USDC; tickSpacing = 40
  "0x301ea2b40e5022d96f9fb96456a3c7ee8a4f65117c35cab17575c1a9fe5a7521": 3e3,
  // wBLT/cbBTC; tickSpacing = 100
  "0x95c221dfe861c2e169ed8cd2a63db99161ec281c13f1349909eb5be681a94af6": 3e3,
  // wBLT/wETH; tickSpacing = 100
  "0xea9d5eea188eaa6d1ce5c776e022638e9131ad180335846496c648e3ca541488": 7e3,
  // wBLT/CDX; tickSpacing = 300
  "0x3779354f8c0065d70f35115508d040008ccf2e6a246d80c4db994e4684e2f72a": 3e3,
  // wBLT/frxUSD; tickSpacing = 40
  "0x659de2d376c483a701e439d6ebd31ef2d8786b19ca8184f8ae4a73c099901ee7": 1e3,
  // wBLT/BNKR; tickSpacing = 200
  "0x52ee48b1a0940a5459fef8e387d17b6e372b92281ab46584a77f220db8d6a008": 6e3
  // wBLT/VEIL; tickSpacing = 200
};
export const HIDDEN_POOL_IDS = /* @__PURE__ */ new Set(["0x1ce5d839d3ad969091fb4fc7160bf803e4766bb2a3a7841e55a7934c1ebcac29"]);
export const DELI_FEE_SCHEDULE = [
  {
    feeAmount: 100,
    tickSpacing: 1
  },
  {
    feeAmount: 300,
    tickSpacing: 10
  },
  {
    feeAmount: 1500,
    tickSpacing: 40
  },
  {
    feeAmount: 3e3,
    tickSpacing: 60
  },
  {
    feeAmount: 4e3,
    tickSpacing: 100
  },
  {
    feeAmount: 6500,
    tickSpacing: 200
  },
  {
    feeAmount: 1e4,
    tickSpacing: 300
  },
  {
    feeAmount: 17500,
    tickSpacing: 400
  },
  {
    feeAmount: 25e3,
    tickSpacing: 600
  }
];
export const DELI_FEE_CONSTANT_PRODUCT_SCHEDULE = [
  {
    feeAmount: 1e3,
    tickSpacing: 1
  },
  {
    feeAmount: 2e3,
    tickSpacing: 10
  },
  {
    feeAmount: 3e3,
    tickSpacing: 40
  },
  {
    feeAmount: 4e3,
    tickSpacing: 60
  },
  {
    feeAmount: 5e3,
    tickSpacing: 100
  },
  {
    feeAmount: 6e3,
    tickSpacing: 200
  },
  {
    feeAmount: 7e3,
    tickSpacing: 300
  },
  {
    feeAmount: 8e3,
    tickSpacing: 400
  }
];
export const DELI_FEE_AMOUNTS = DELI_FEE_SCHEDULE.map((config) => config.feeAmount);
export const DELI_TICK_SPACINGS = DELI_FEE_SCHEDULE.reduce(
  (acc, config) => {
    acc[config.feeAmount] = config.tickSpacing;
    return acc;
  },
  {}
);
export const DELI_FEE_TITLE_KEYS = DELI_FEE_SCHEDULE.reduce(
  (acc, config) => {
    if (config.titleKey) {
      acc[config.feeAmount] = config.titleKey;
    }
    return acc;
  },
  {}
);
export const DELI_BASE_WHITELISTED_INCENTIVES = [
  {
    address: "0x548f93779fBC992010C07467cBaf329DD5F059B7",
    symbol: "BMX",
    decimals: 18
  },
  {
    address: "0x4E74D4Db6c0726ccded4656d0BCE448876BB4C7A",
    symbol: "wBLT",
    decimals: 18
  },
  {
    address: "0x4200000000000000000000000000000000000006",
    symbol: "wETH",
    decimals: 18
  },
  {
    address: "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913",
    symbol: "USDC",
    decimals: 6
  },
  {
    address: "0x2260FAC5E5542a773Aa44fBCfeDf7C193bc2C599",
    symbol: "cbBTC",
    decimals: 8
  },
  {
    address: "0x940181a94A35A4569E4529A3CDfB74e38FD98631",
    symbol: "AERO",
    decimals: 18
  },
  {
    address: "0x0d97F261b1e88845184f678e2d1e7a98D9FD38dE",
    symbol: "TYBG",
    decimals: 18
  },
  {
    address: "0x767A739D1A152639e9Ea1D8c1BD55FDC5B217D7f",
    symbol: "VEIL",
    decimals: 18
  },
  {
    address: "0x22aF33FE49fD1Fa80c7149773dDe5890D3c76F3b",
    symbol: "BNKR",
    decimals: 18
  },
  {
    address: "0x0b3e328455c4059EEb9e3f84b5543F74E24e7E1b",
    symbol: "VIRTUAL",
    decimals: 18
  },
  {
    address: "0xBAa5CC21fd487B8Fcc2F632f3F4E8D37262a0842",
    symbol: "MORPHO",
    decimals: 18
  },
  {
    address: "0x1bc0c42215582d5A085795f4baDbaC3ff36d1Bcb",
    symbol: "CLANKER",
    decimals: 18
  },
  {
    address: "0xB3B32F9f8827D4634fE7d973Fa1034Ec9fdDB3B3",
    symbol: "B3",
    decimals: 18
  },
  {
    address: "0x4ed4E862860beD51a9570b96d89aF5E1B0Efefed",
    symbol: "DEGEN",
    decimals: 18
  },
  {
    address: "0xED6E000dEF95780fb89734c07EE2ce9F6dcAf110",
    symbol: "EDGE",
    decimals: 18
  },
  {
    address: "0xA88594D404727625A9437C3f886C7643872296AE",
    symbol: "WELL",
    decimals: 18
  },
  {
    address: "0x7300B37DfdfAb110d83290A29DfB31B1740219fE",
    symbol: "MAMO",
    decimals: 18
  },
  {
    address: "0x6921B130D297cc43754afba22e5EAc0FBf8Db75b",
    symbol: "doginme",
    decimals: 18
  },
  {
    address: "0xB1a03EdA10342529bBF8EB700a06C60441fEf25d",
    symbol: "MIGGLES",
    decimals: 18
  },
  {
    address: "0x0CEAC003B0d2479BebeC9f4b2EBAd0a803759bbf",
    symbol: "wFRAX",
    decimals: 18
  }
];
export const DELI_BMX_ADDRESS = "0x548f93779fBC992010C07467cBaf329DD5F059B7";
export const DELI_WBLT_ADDRESS = "0x4E74D4Db6c0726ccded4656d0BCE448876BB4C7A";
export const WBLT_INFO_URL = "https://wblt-tools.vercel.app/";
export const BMX_WBLT_POOL_ID = "0xa900d06df8073e50a50971720d6d3470d00e64198da3b03c82388f247e0d13c1";
export const BMX_ETH_UNISWAP_URL = "https://app.uniswap.org/explore/pools/base/0xe6d3ad025d7d85be9c24d716be35b3040fcc26e3fd8fd49d2ed86ad2c678e064?utm_source=share-pool&utm_medium=web";
export const DELI_INCENTIVE_GAUGE_ADDRESS = "0x59d7bFF1934939A7cD11E029c051Ba9872469213";
export const DELI_INCENTIVE_GAUGE_ABI = [
  {
    anonymous: false,
    inputs: [
      { indexed: true, internalType: "address", name: "user", type: "address" },
      { indexed: true, internalType: "contract IERC20", name: "token", type: "address" },
      { indexed: false, internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "Claimed",
    type: "event"
  },
  {
    inputs: [
      { internalType: "uint256", name: "tokenId", type: "uint256" },
      { internalType: "contract IERC20", name: "token", type: "address" },
      { internalType: "address", name: "to", type: "address" }
    ],
    name: "claim",
    outputs: [{ internalType: "uint256", name: "amount", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "PoolId[]", name: "pids", type: "bytes32[]" },
      { internalType: "address", name: "owner", type: "address" }
    ],
    name: "claimAllForOwner",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          { internalType: "Currency", name: "currency0", type: "address" },
          { internalType: "Currency", name: "currency1", type: "address" },
          { internalType: "uint24", name: "fee", type: "uint24" },
          { internalType: "int24", name: "tickSpacing", type: "int24" },
          { internalType: "contract IHooks", name: "hooks", type: "address" }
        ],
        internalType: "struct PoolKey",
        name: "key",
        type: "tuple"
      },
      { internalType: "contract IERC20", name: "rewardToken", type: "address" },
      { internalType: "uint256", name: "amount", type: "uint256" }
    ],
    name: "createIncentive",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
export const WBLT_ROUTER_ADDRESS = "0x35E37D0b4960141740135e0742579aEfE5F9d598";
export const WBLT_ROUTER_ABI = [
  {
    inputs: [
      { internalType: "address", name: "_receiver", type: "address" },
      { internalType: "address", name: "_fromToken", type: "address" },
      { internalType: "uint256", name: "_amount", type: "uint256" }
    ],
    name: "depositToWrappedBLT",
    outputs: [{ internalType: "uint256", name: "amountReceived", type: "uint256" }],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      { internalType: "address", name: "_token", type: "address" },
      { internalType: "uint256", name: "_amount", type: "uint256" }
    ],
    name: "getMintAmountWrappedBLT",
    outputs: [{ internalType: "uint256", name: "wrappedBLTMintAmount", type: "uint256" }],
    stateMutability: "view",
    type: "function"
  }
];
export const BMX_STAKING_ROUTER_ADDRESS = "0x6456039168d3fE3Bc5FCD9e46f3B716C1AbD4ff4";
export const STAKED_BMX_TRACKER_ADDRESS = "0x3085F25Cbb5F34531229077BAAC20B9ef2AE85CB";
export const BMX_STAKING_ROUTER_ABI = [
  {
    inputs: [{ internalType: "uint256", name: "_amount", type: "uint256" }],
    name: "stakeBmx",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
];
